





import { Component, Vue,Watch } from 'vue-property-decorator';
import ShowIncomingPhoneNumber from "@/components/numbers/ShowIncomingPhoneNumber.vue";
import IncomingPhoneNumberList from "@/components/numbers/IncomingPhoneNumberList.vue";

@Component({
    components:{

        IncomingPhoneNumberList,
        ShowIncomingPhoneNumber,
    }
})
export default class Numbers extends Vue {
    private incomingPhoneNumberSid: string | null = null;

    @Watch('$route')
    routeChanged() {
        this.changeRoute();
    }

    changeRoute() {
        if (this.$route.params != null && this.$route.params.sid != null) {
            this.incomingPhoneNumberSid = String(this.$route.params.sid);
        } else {
            this.incomingPhoneNumberSid = null;
        }
        console.log(this.$route.params);
    }

    mounted() {
        this.changeRoute();
        //
    }
}
